/* eslint-disable no-useless-escape */
export const getCookie = (cookieName: string) =>
	decodeURIComponent(
		document.cookie.replace(
			new RegExp(
				"(?:(?:^|.*;)\\s*" +
					encodeURIComponent(cookieName).replace(/[\-\.\+\*]/g, "\\$&") +
					"\\s*\\=\\s*([^;]*).*$)|^.*$",
			),
			"$1",
		),
	) || null;
